<!--
     <DirectoryInput
       :props="my_attrs_dictionary"
     />

     Public propertys:
       value → Gives the field's serializable value

     Public methods:
       validate → Makes validation and returns if the value is valid

     Accepted props:
     - label
-->

<template>
  <v-container fluid class="pa-0 mb-5">
    <v-row>
      <v-col
        style="font-size: 16px"
      >
        {{ props.label || 'Carpeta:' }}
        <ExplorerDirectoryPath
          class="ml-4"
          :path="path"
        >
        </ExplorerDirectoryPath>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
 import { mapState } from 'vuex'
 import ExplorerDirectoryPath from '@/components/explorer/ExplorerDirectoryPath'

 export default {
   name: 'DirectoryInput',

   components: {
     ExplorerDirectoryPath,
   },

   props: ['props', 'required_rule'],

   data: (() => ({
   })),

   computed: {
     ...mapState([
       'activeDirectory',
       'qdirectory'
     ]),

     path() {
       return (
         this.props.value ?
         this.qdirectory[this.props.value].path
         : this.activeDirectory.path
       );
     },

     value() {
       return this.props.value || this.activeDirectory.id;
     },
   },

   methods: {
     validate() {
       return true;
     },
   },
 }
</script>
